import { mapActions, mapGetters } from 'vuex'
import { ACTIONS, GETTERS } from '@/store'
import { normalizeLowerCase } from '@/utils/matchString'

export default {
  computed: {
    ...mapGetters({
      poisList: GETTERS.GET_POIS_LIST,
      uncategorizedPoisList: GETTERS.GET_UNCATEGORIZED_POIS_LIST,
      hasRoute: GETTERS.HAS_ROUTE,
      routeDefaultLevel: GETTERS.GET_ROUTE_DEFAULT_LEVEL_BUILDING
    })
  },
  methods: {
    ...mapActions([
      ACTIONS.LOAD_FLOOR,
      ACTIONS.LOAD_POI
    ]),
    saveFloor ({ buildingId, floorId, force = false, airportID, tag = 'mapa', event = false }) {
      const building = this.buildings.find(x => x.id === buildingId)

      if (building) {
        const altLevel = this.routeDefaultLevel[building.id] ? this.routeDefaultLevel[building.id] : floorId
        const levelId = !this.hasRoute || force ? floorId : altLevel
        const floor = building.levels.find(x => x.id === levelId)

        if (event) {
          const label = `${building.name}. Planta ${floor.name}`
          const tagFloor = {
            'eventCategory': tag,
            'eventAction': 'clic',
            'eventLabel': `${normalizeLowerCase(label)}`,
            'language': this.$i18n.locale,
            'airportID': airportID
          }
          window.digitalChange('event', tagFloor)
        }
        return this[ACTIONS.LOAD_FLOOR]({ building, floor })
      }
    },
    findPoi (poiId) {
      let poi = this.poisList.features.find(x => x.properties.id === poiId)
      if (!poi) {
        poi = this.uncategorizedPoisList.features.find(x => x.properties.id === poiId)
      }
      return poi
    },
    savePoi ({ poiId, pointGrouped, airportID, tag }) {
      const poi = this.findPoi(poiId)
      const floor = poi.properties.level
      const building = poi.properties.building

      this.saveFloor({ buildingId: building, floorId: floor, airportID, tag })
      return this[ACTIONS.LOAD_POI]({ poi, pointGrouped })
    }
  }
}
